import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaSelfcare',
			dom: {
				item: '.js-selfcare-item',
				slide: '.js-selfcare-slide'
			},
			classes: {
				item: 'b-selfcare__item_state_active',
				slide: 'b-selfcare__slide_state_active'
			}
		};

		this.active = -1;

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$slide = this.$el.find(this.options.dom.slide);
		this.$item = this.$el.find(this.options.dom.item);
		return this;
	}

	onHover(e) {
		const index = $(e.currentTarget).index();
		this.setActive(index);
	}

	onLeave() {
		const self = this;
		self.setActive(self.active);
	}

	onClick(e) {
		const index = $(e.currentTarget).index();
		this.active = index;
	}

	setActive(e) {
		const $target = typeof e == 'number' ? this.$item.eq(e) : $(e.currentTarget);
		const index = $target.index();
		if (this.active == -1) {
			this.active = index;
		}
		this.$item.removeClass(this.options.classes.item);
		this.$slide.removeClass(this.options.classes.slide);
		this.$item.eq(index).addClass(this.options.classes.item);
		this.$slide.eq(index).addClass(this.options.classes.slide);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$item.on('mouseover', this.onHover.bind(this));
			this.$item.on('mouseleave', this.onLeave.bind(this));
			this.$item.on('click', this.onClick.bind(this));
			this.setActive(0);
		}
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/selfcare/selfcare.js